import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type {
  IUpdateMeApiPayload,
  IUsersMeApiResponse,
  IUsersMeApiUser,
} from '../types/UsersMe.api';
import { USERS_ME_PATH } from './authServiceApiBase';

/**
 * Saves the signed-in person's own name. Never routed through `PATCH /users`,
 * so a selected child office can never receive it; `x-office` is stripped.
 */
export const updateMe = async (payload: IUpdateMeApiPayload): Promise<IUsersMeApiUser> => {
  const headers = await getAuthHeaders();
  const { data } = await tempMeeApi.patch<IUsersMeApiResponse>(USERS_ME_PATH, payload, {
    headers: { ...headers, 'x-office': undefined },
  });
  return data.data;
};
